var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M4.766-2.266A2.407,2.407,0,0,1,5.5-.5a2.407,2.407,0,0,1-.734,1.766A2.407,2.407,0,0,1,3,2a2.407,2.407,0,0,1-1.766-.734A2.407,2.407,0,0,1,.5-.5a2.407,2.407,0,0,1,.734-1.766A2.407,2.407,0,0,1,3-3,2.407,2.407,0,0,1,4.766-2.266ZM.781-13.219A.776.776,0,0,1,1-13.766.7.7,0,0,1,1.531-14H4.469A.7.7,0,0,1,5-13.766a.776.776,0,0,1,.219.547l-.437,8.5a.673.673,0,0,1-.219.516.752.752,0,0,1-.531.2H1.969a.752.752,0,0,1-.531-.2.673.673,0,0,1-.219-.516Z",
    transform: "translate(-0.5 14)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.dd9f084ac8b67a4879c2da4b28b0d9cd.svg";
export { ForwardRef as ReactComponent };